import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { UsuarioRedux } from 'src/app/models/usuario.model';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  currentUser: UsuarioRedux=null;

  anio = new Date().getFullYear();
  constructor(
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.store.select("usuarioApp").subscribe((response)=>{
        this.currentUser = response.currentUser;    
    })
  }

}
